<template>
  <div>
    <h1>{{ pageTitle }}</h1>
  </div>
</template>

<script>
// import Color from '@/components/Color.vue'
export default {
  components: {
    // Color
  },
  data () {
    return {
      pageTitle: 'Icons'
    }
  }
}
</script>
